export { getStoresList } from 'next-flight-server-reference-proxy-loader?id=6041b2f49cecc0852d1204c36d087ef4ddcb0e93e4&name=getStoresList!'